import { ValidationErrorData } from './common';

export interface KeywordsData {
    id?: string;
    phrase: string;
    minusWords: string[];
}

export enum KeywordsEditorDataTabs {
    SIMPLE_TAB = 0,
    FORECAST_TAB = 1
}

export enum KeywordsEditorBodyView {
    short = 'short',
    full = 'full'
}

export interface KeywordsEditorData {
    value: KeywordsData[];
    input: string;
    isOpen: boolean;
    errors: ValidationErrorData[];
    isStatLoading: boolean;
    keywordStats: number[];
    selectedTabIndex: number;
    view: KeywordsEditorBodyView;
    refinedKeywordIndex?: number;
}

export interface KeywordsEditorsState {
    editors: Record<string, KeywordsEditorData>;
}
